import { MapPin, Scissors, Heart } from "lucide-react";

const values = [
  {
    icon: MapPin,
    title: "Norskprodusert",
    description: "Alle våre bunader er produsert i Norge, med norske materialer og norsk håndverk.",
  },
  {
    icon: Scissors,
    title: "Skreddersydd",
    description: "Alle bunader blir tilpasset hver enkelt kunde for perfekt passform.",
  },
  {
    icon: Heart,
    title: "Tradisjon",
    description: "Vi er opptatt av å bringe gode bunadstradisjoner videre til nye generasjoner.",
  },
];

const Values = () => {
  return (
    <section aria-labelledby="values-heading" className="section-padding bg-charcoal text-white">
      <div className="max-w-7xl mx-auto">
        <h2 id="values-heading" className="sr-only">Våre verdier</h2>
        <div className="grid md:grid-cols-3 gap-12 lg:gap-16" role="list">
          {values.map((value) => (
            <div key={value.title} className="text-center" role="listitem">
              <div className="w-16 h-16 rounded-full border border-white/30 flex items-center justify-center mx-auto mb-6" aria-hidden="true">
                <value.icon className="w-7 h-7 text-white" />
              </div>
              <h3 className="font-serif text-xl mb-3">
                {value.title}
              </h3>
              <p className="text-white/80 font-sans text-sm leading-relaxed">
                {value.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Values;
